export const MAX_EVIDENCE_BYTES = 25 * 1024 * 1024; // 25MB

export const ALLOWED_EVIDENCE_MIME_TYPES = [
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/bmp',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.ms-powerpoint',
    'application/zip',
    'application/x-zip-compressed',
    'application/vnd.rar',
    'application/x-rar-compressed',
    'message/rfc822',
    'application/vnd.ms-outlook',
];

export const ALLOWED_EVIDENCE_EXTENSIONS = [
    '.pdf',
    '.png',
    '.jpg',
    '.jpeg',
    '.bmp',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.ppt',
    '.pptx',
    '.zip',
    '.rar',
    '.eml',
    '.msg',
];
